/* lua.js generated code 0.3.0 */

PropBagAnimation = {}
PropBagAnimation.addItemsToBag = function (itemConfigs, onAnimFinish, interval, destPos, iconPath = "homeScene/backpack.png") {
    var self = this
    var wSize = cc.Director.getInstance().getWinSize()
    var flyToBag = true
    if (destPos) {
        flyToBag = false
    } else {
        destPos = cc.p(wSize.width - 60, 280)
    }
    var interval = interval || 0
    var totalCount = $len(itemConfigs)
    if (!itemConfigs || type(itemConfigs) !== "table" || $len(itemConfigs) === 0) {
        return 
    }
    //背包放右边了。。从右往左飞
    table.sort(itemConfigs, function (a, b) {
        return a.pos.x > b.pos.x
    })
    var scene = cc.Director.getInstance().getRunningScene()
    if (!scene) {
        return 
    }
    var animationLayer = cc.Layer.create()
    scene.addChild(animationLayer, 1100)
    var bagButton = null
    bagButton = cc.Sprite.createWithSpriteFrameName(iconPath)
    bagButton.setPosition(destPos)
    animationLayer.addChild(bagButton, 10)

    var finishCount = 0
    function flyFinish() {
        finishCount = finishCount + 1
        if (finishCount >= totalCount) {
            animationLayer.removeFromParent(true)
            if (onAnimFinish) {
                onAnimFinish()
            }
        }
    }
    function onReachBag() {
        // if (flyToBag) {
            bagButton.runAction(cc.Sequence.create(cc.ScaleTo.create(0.1, 1.2), cc.ScaleTo.create(0.1, 1), cc.CallFunc.create(flyFinish)))
        // } else {
        //     flyFinish()
        // }
    }
    for (let k = 1, v = itemConfigs[1]; v; k++, v = itemConfigs[k]) {
        var scale = v.scale || 1
        let icon = v["itemSpUrl"] == null? UIItemBuilder.createProp(v.itemId, v.num, v.iconType)[0]: cc.Sprite.create(v.itemSpUrl);
        icon.setPosition(v.pos)
        icon.setScale(scale)
        animationLayer.addChild(icon)
        var delayTime = interval * (k - 1)
        var midPoint = cc.p((destPos.x + v.pos.x) / 2, Math.max(destPos.y, v.pos.y) + 100)
        var bezierConfig1 = table(
            [0, cc.p(v.pos.x, (v.pos.y + midPoint.y) / 2)],
            [0, cc.p((v.pos.x + midPoint.x) / 2, midPoint.y)],
            [0, midPoint]
        )
        var bezierConfig2 = table(
            [0, cc.p((destPos.x + midPoint.x) / 2, midPoint.y)],
            [0, cc.p(destPos.x, (destPos.y + midPoint.y) / 2)],
            [0, destPos]
        )
        icon.runAction(cc.Sequence.create(
            cc.DelayTime.create(delayTime), 
            cc.EaseOut.create(cc.MoveTo.create(0.1, cc.p(v.pos.x + 5, v.pos.y - 10)), 0.5),
            cc.DelayTime.create(v.showTimes || 0),
            cc.EaseOut.create(cc.BezierTo.create(0.3, bezierConfig1), 1.25), 
            cc.EaseOut.create(cc.BezierTo.create(0.3, bezierConfig2), 0.8), 
            cc.CallFunc.create(onReachBag), 
            cc.RemoveSelf.create(true)
        ))
    }
}
//-[[
PropBagAnimation.addItems = function (itemList, callback, interval) {
    var self = this
    var animatorCount = 0
    function flyFinish() {
        animatorCount = animatorCount - 1
        if (animatorCount <= 0) {
            if (callback) {
                callback()
            }
        }
    }
    var finishCount = 0
    var flyItemConfig = table()
    for (let k = 1, v = itemList[1]; v; k++, v = itemList[k]) {
        if (v.itemId === GamePropIds.kCoin) {
            animatorCount = animatorCount + 1
            HomeSceneAnimation.playGetCoinAnimation(v.num, v.pos, v.scale || 0.8, flyFinish)
        } else {
            table.insert(flyItemConfig, v)
        }
    }
    if ($len(flyItemConfig) > 0) {
        animatorCount = animatorCount + 1
        PropBagAnimation.addItemsToBag(flyItemConfig, flyFinish, interval)
    }
}
// 
PropBagAnimation.addItemsToStartBtn = function(itemConfigs, onAnimFinish, interval){
    var self = this
    // var wSize = cc.Director.getInstance().getWinSize()
    let startBtnPosY = cc.winSize.height / 2
    let islandNodeHeight = 602
    let bottomHeight = 130
    let posy = Math.max(200, (startBtnPosY - islandNodeHeight / 2 - bottomHeight) / 2 + bottomHeight + 25)

    // let destPos = cc.p(wSize.width - 60, 280)
    let destPos = cc.p(cc.winSize.width / 2, posy)


    var interval = interval || 0
    var totalCount = $len(itemConfigs)
    if (!itemConfigs || type(itemConfigs) !== "table" || $len(itemConfigs) === 0) {
        return 
    }
  
    var scene = cc.Director.getInstance().getRunningScene()
    if (!scene) {
        return 
    }
    var animationLayer = cc.Layer.create()
    scene.addChild(animationLayer, 1100)
    // var bagButton = null
    // bagButton = cc.Sprite.createWithSpriteFrameName(iconPath)
    // bagButton.setPosition(destPos)
    // animationLayer.addChild(bagButton, 10)

    var finishCount = 0
    function flyFinish() {
        finishCount = finishCount + 1
        if (finishCount >= totalCount) {
            animationLayer.removeFromParent(true)
            if (onAnimFinish) {
                onAnimFinish()
            }
        }
    }
    function onReachBag() {
        // if (flyToBag) {
            // bagButton.runAction(cc.Sequence.create(cc.ScaleTo.create(0.1, 1.2), cc.ScaleTo.create(0.1, 1), cc.CallFunc.create(flyFinish)))
        // } else {
        //     flyFinish()
        // }
        pcall(function(){
            let homeScene = require("clover/scene/HomeScene").getInstance()
            homeScene.updateStartBtnLevelCollect(true)
        })
        flyFinish()
    }
    for (let k = 1, v = itemConfigs[1]; v; k++, v = itemConfigs[k]) {
        var scale = v.scale || 1
        let icon = v["itemSpUrl"] == null? UIItemBuilder.createProp(v.itemId, v.num, v.iconType)[0]: cc.Sprite.create(v.itemSpUrl);
        icon.setPosition(v.pos)
        icon.setScale(scale)
        animationLayer.addChild(icon)
        var delayTime = interval * (k - 1)
        var midPoint = cc.p((destPos.x + v.pos.x) / 2, Math.max(destPos.y, v.pos.y) + 100)
        var bezierConfig1 = table(
            [0, cc.p(v.pos.x, (v.pos.y + midPoint.y) / 2)],
            [0, cc.p((v.pos.x + midPoint.x) / 2, midPoint.y)],
            [0, midPoint]
        )
        var bezierConfig2 = table(
            [0, cc.p((destPos.x + midPoint.x) / 2, midPoint.y)],
            [0, cc.p(destPos.x, (destPos.y + midPoint.y) / 2)],
            [0, destPos]
        )
        icon.runAction(cc.Sequence.create(
            cc.DelayTime.create(delayTime), 
            cc.EaseOut.create(cc.MoveTo.create(0.1, cc.p(v.pos.x + 5, v.pos.y - 10)), 0.5),
            cc.DelayTime.create(v.showTimes || 0),
            cc.EaseOut.create(cc.BezierTo.create(0.3, bezierConfig1), 1.25), 
            cc.EaseOut.create(cc.BezierTo.create(0.3, bezierConfig2), 0.8), 
            cc.CallFunc.create(onReachBag), 
            cc.RemoveSelf.create(true)
        ))
    }
}

PropBagAnimation.addItemsToProfile = function (itemConfigs, onAnimFinish, interval, destPos, iconPath = "homeScene/profile.png") {
    var self = this
    var wSize = cc.Director.getInstance().getWinSize()
    var flyToBag = true
    if (destPos) {
        flyToBag = false
    } else {
        destPos = cc.p(wSize.width - 60, 400)
    }
    var interval = interval || 0
    var totalCount = $len(itemConfigs)
    if (!itemConfigs || type(itemConfigs) !== "table" || $len(itemConfigs) === 0) {
        return 
    }
    //背包放右边了。。从右往左飞
    table.sort(itemConfigs, function (a, b) {
        return a.pos.x > b.pos.x
    })
    var scene = cc.Director.getInstance().getRunningScene()
    if (!scene) {
        return 
    }
    var animationLayer = cc.Layer.create()
    scene.addChild(animationLayer, 1100)
    var bagButton = null
    bagButton = cc.Sprite.createWithSpriteFrameName(iconPath)
    bagButton.setPosition(destPos)
    animationLayer.addChild(bagButton, 10)

    var finishCount = 0
    function flyFinish() {
        finishCount = finishCount + 1
        if (finishCount >= totalCount) {
            animationLayer.removeFromParent(true)
            if (onAnimFinish) {
                onAnimFinish()
            }
        }
    }
    function onReachBag() {
        // if (flyToBag) {
            bagButton.runAction(cc.Sequence.create(cc.ScaleTo.create(0.1, 1.2), cc.ScaleTo.create(0.1, 1), cc.CallFunc.create(flyFinish)))
        // } else {
        //     flyFinish()
        // }
    }
    for (let k = 1, v = itemConfigs[1]; v; k++, v = itemConfigs[k]) {
        var scale = v.scale || 1
        let icon = v["itemSpUrl"] == null? UIItemBuilder.createProp(v.itemId, v.num, v.iconType)[0]: cc.Sprite.create(v.itemSpUrl);
        icon.setPosition(v.pos)
        icon.setScale(scale)
        animationLayer.addChild(icon)
        var delayTime = interval * (k - 1)
        var midPoint = cc.p((destPos.x + v.pos.x) / 2, Math.max(destPos.y, v.pos.y) + 100)
        var bezierConfig1 = table(
            [0, cc.p(v.pos.x, (v.pos.y + midPoint.y) / 2)],
            [0, cc.p((v.pos.x + midPoint.x) / 2, midPoint.y)],
            [0, midPoint]
        )
        var bezierConfig2 = table(
            [0, cc.p((destPos.x + midPoint.x) / 2, midPoint.y)],
            [0, cc.p(destPos.x, (destPos.y + midPoint.y) / 2)],
            [0, destPos]
        )
        icon.runAction(cc.Sequence.create(
            cc.DelayTime.create(delayTime), 
            cc.EaseOut.create(cc.MoveTo.create(0.1, cc.p(v.pos.x + 5, v.pos.y - 10)), 0.5),
            cc.DelayTime.create(v.showTimes || 0),
            cc.EaseOut.create(cc.BezierTo.create(0.3, bezierConfig1), 1.25), 
            cc.EaseOut.create(cc.BezierTo.create(0.3, bezierConfig2), 0.8), 
            cc.CallFunc.create(onReachBag), 
            cc.RemoveSelf.create(true)
        ))
    }
}
//]]
module.exports = PropBagAnimation
